import styled from "styled-components";

export const Section = styled.section`
	background: #fff;
	width: 100%;
`;
